var map = {
	"./157755464821593074.gif": 271,
	"./Hyderabad_Growth_API_Documentation.txt": 272,
	"./If-you-snore.pdf": 114,
	"./about-banner1.png": 273,
	"./about-banner2.png": 274,
	"./achievement.jpg": 115,
	"./appointment.png": 275,
	"./author-img.png": 116,
	"./banner-promo.png": 276,
	"./blog/b1.jpg": 117,
	"./blog/b2.jpg": 118,
	"./blog/b3.jpg": 119,
	"./blog/blog1.jpg": 120,
	"./blog/blog2.jpg": 121,
	"./blog/blog3.jpg": 122,
	"./brand/1.png": 277,
	"./brand/2.png": 278,
	"./brand/3.png": 279,
	"./brand/4.png": 280,
	"./brand/5.png": 281,
	"./brand/6.png": 282,
	"./comment1.png": 57,
	"./comment2.png": 123,
	"./d1.png": 283,
	"./d2.png": 284,
	"./d3.png": 285,
	"./dentist-profile-img.jpg": 124,
	"./dento_video.jpg": 286,
	"./doc/1.jpg": 287,
	"./doc/2.jpg": 288,
	"./doc/3.jpg": 289,
	"./doctor-nars.png": 290,
	"./doctorfinding.png": 291,
	"./experienceddentist.png": 292,
	"./favicon.png": 293,
	"./featured-img.jpg": 125,
	"./featured_icon_bg.png": 294,
	"./funfact_bg.png": 295,
	"./gallery/1.jpg": 296,
	"./gallery/2.jpg": 297,
	"./gallery/3.jpg": 298,
	"./gallery/4.jpg": 299,
	"./gallery/5.jpg": 300,
	"./gallery/g1.jpg": 301,
	"./gallery/g2.jpg": 302,
	"./gallery/g3.jpg": 303,
	"./gallery/g4.jpg": 304,
	"./gallery/g5.jpg": 305,
	"./generic-lady.png": 306,
	"./generic-men.jpg": 307,
	"./hero-img-bg.png": 308,
	"./hero-theeth.png": 309,
	"./home_two_slide.jpg": 310,
	"./icons/appointment.svg": 311,
	"./icons/availability.svg": 312,
	"./icons/braces.svg": 313,
	"./icons/check.svg": 314,
	"./icons/clock.svg": 315,
	"./icons/cracked.svg": 316,
	"./icons/dental-implant.svg": 317,
	"./icons/dentist.svg": 318,
	"./icons/dentistry.svg": 319,
	"./icons/dictionary.svg": 320,
	"./icons/general.svg": 321,
	"./icons/icon.svg": 322,
	"./icons/icon3.svg": 323,
	"./icons/implants.svg": 324,
	"./icons/like.png": 325,
	"./icons/love.png": 326,
	"./icons/molar-with-cavity.svg": 327,
	"./icons/oral.svg": 328,
	"./icons/phone-call.svg": 329,
	"./icons/phone-call2.svg": 330,
	"./icons/respect.png": 331,
	"./icons/right-arrow.svg": 332,
	"./icons/selants.svg": 333,
	"./icons/teeth.svg": 334,
	"./icons/tooth.svg": 335,
	"./icons/tooth2.svg": 336,
	"./logo.png": 337,
	"./logo_2.png": 338,
	"./page-banner/1.png": 339,
	"./page-banner/2.png": 340,
	"./page-banner/3.png": 341,
	"./page-banner/4.png": 126,
	"./page-banner/5.png": 127,
	"./preloader.gif": 342,
	"./promo_bg.png": 343,
	"./review.png": 344,
	"./service-details-promo1.png": 128,
	"./service-details-promo2.png": 129,
	"./shape/aab.png": 10,
	"./shape/bluef.png": 37,
	"./shape/circle1.png": 41,
	"./shape/dotf.png": 345,
	"./shape/dotmr.png": 20,
	"./shape/dotw.png": 346,
	"./shape/plusb.png": 35,
	"./shape/plusg.png": 34,
	"./shape/plusgs.png": 14,
	"./shape/plusr.png": 15,
	"./shape/rmc.png": 18,
	"./shape/sgdot.png": 19,
	"./shape/xsrdot.png": 36,
	"./sleep-brochure-cover.png": 130,
	"./sleep-brochure.pdf": 131,
	"./subscribe.png": 347,
	"./testi1.png": 348,
	"./video-bg1.jpg": 132,
	"./video-bg2.jpg": 133,
	"./whatsinaname/404Page.png": 134,
	"./whatsinaname/AboutNewImage.png": 99,
	"./whatsinaname/AboutUs.png": 349,
	"./whatsinaname/BannerBackground.png": 350,
	"./whatsinaname/BannerImage.png": 93,
	"./whatsinaname/Blog01.jpg": 351,
	"./whatsinaname/Blog02.jpg": 352,
	"./whatsinaname/Blog03.jpg": 353,
	"./whatsinaname/CGR Academy Brochure..pdf": 354,
	"./whatsinaname/ConsultSpecialists.png": 58,
	"./whatsinaname/Consultousleep.png": 135,
	"./whatsinaname/DoctorLanding.jpg": 42,
	"./whatsinaname/Header-logo.png": 59,
	"./whatsinaname/Headerlogo.png": 355,
	"./whatsinaname/HomePageBanner.jpg": 356,
	"./whatsinaname/Icons/24x7Security.png": 136,
	"./whatsinaname/Icons/AboutIcon01.png": 137,
	"./whatsinaname/Icons/AboutIcon02.png": 138,
	"./whatsinaname/Icons/AboutIcon03.png": 139,
	"./whatsinaname/Icons/AdvancedEquipment.png": 140,
	"./whatsinaname/Icons/AlsoOpen.png": 141,
	"./whatsinaname/Icons/AmpleParking.png": 142,
	"./whatsinaname/Icons/BAllergyClinic.png": 143,
	"./whatsinaname/Icons/BILDClinic.png": 144,
	"./whatsinaname/Icons/BLungCancerClinic.png": 145,
	"./whatsinaname/Icons/BLungHealthClinic.png": 146,
	"./whatsinaname/Icons/BLungInfectionClinic.png": 147,
	"./whatsinaname/Icons/BSmokingDeaddictionClinic.png": 148,
	"./whatsinaname/Icons/Dr image.jpg": 357,
	"./whatsinaname/Icons/HolisticTreatment.png": 149,
	"./whatsinaname/Icons/LeadingDoctors.png": 150,
	"./whatsinaname/Icons/Multi-disciplinary.png": 151,
	"./whatsinaname/Icons/PremiumSleep.png": 152,
	"./whatsinaname/Icons/State-of-the-art.png": 153,
	"./whatsinaname/PartnerWithUs/Icon01.png": 154,
	"./whatsinaname/PartnerWithUs/Icon02.png": 155,
	"./whatsinaname/PartnerWithUs/Icon03.png": 156,
	"./whatsinaname/Qualification/01.png": 157,
	"./whatsinaname/Qualification/02.png": 158,
	"./whatsinaname/Qualification/03.png": 159,
	"./whatsinaname/Qualification/04.png": 160,
	"./whatsinaname/Qualification/05.png": 161,
	"./whatsinaname/Qualification/06.png": 162,
	"./whatsinaname/Qualification/07.png": 163,
	"./whatsinaname/Qualification/08.png": 164,
	"./whatsinaname/Qualification/09.png": 165,
	"./whatsinaname/Qualification/10.png": 166,
	"./whatsinaname/Qualification/11.png": 167,
	"./whatsinaname/awards/01.png": 168,
	"./whatsinaname/awards/02.png": 169,
	"./whatsinaname/awards/03.png": 170,
	"./whatsinaname/awards/04.png": 171,
	"./whatsinaname/awards/05.png": 172,
	"./whatsinaname/doctor-2.jpg": 173,
	"./whatsinaname/doctor-2.png": 358,
	"./whatsinaname/doctor-2.webp": 359,
	"./whatsinaname/gallery/Image01.png": 174,
	"./whatsinaname/gallery/Image02.png": 175,
	"./whatsinaname/gallery/Image03.png": 176,
	"./whatsinaname/gallery/Image04.png": 177,
	"./whatsinaname/gallery/Image05.png": 178,
	"./whatsinaname/gallery/innerpage/GalleryImage01.jpg": 179,
	"./whatsinaname/gallery/innerpage/GalleryImage02.jpg": 180,
	"./whatsinaname/gallery/innerpage/GalleryImage03.jpg": 181,
	"./whatsinaname/gallery/innerpage/GalleryImage04.jpg": 182,
	"./whatsinaname/gallery/innerpage/GalleryImage05.jpg": 183,
	"./whatsinaname/gallery/innerpage/GalleryImage06.jpg": 184,
	"./whatsinaname/gallery/innerpage/GalleryImage07.jpg": 185,
	"./whatsinaname/gallery/innerpage/GalleryImage08.jpg": 186,
	"./whatsinaname/gallery/innerpage/GalleryImage09.jpg": 187,
	"./whatsinaname/gallery/innerpage/GalleryImage10.jpg": 188,
	"./whatsinaname/gallery/innerpage/GalleryImage11.jpg": 189,
	"./whatsinaname/gallery/innerpage/GalleryImage12.jpg": 190,
	"./whatsinaname/gallery/innerpage/GalleryImage13.jpg": 191,
	"./whatsinaname/gallery/innerpage/GalleryImage14.jpg": 192,
	"./whatsinaname/gallery/innerpage/GalleryImage15.jpg": 193,
	"./whatsinaname/gallery/innerpage/GalleryImage16.jpg": 194,
	"./whatsinaname/gallery/innerpage/GalleryImage17.jpg": 195,
	"./whatsinaname/gallery/innerpage/GalleryImage18.jpg": 196,
	"./whatsinaname/gallery/innerpage/NewImg/01.webp": 197,
	"./whatsinaname/gallery/innerpage/NewImg/03.webp": 198,
	"./whatsinaname/gallery/innerpage/NewImg/04.webp": 199,
	"./whatsinaname/gallery/innerpage/NewImg/05.webp": 200,
	"./whatsinaname/gallery/innerpage/NewImg/06.webp": 201,
	"./whatsinaname/gallery/innerpage/NewImg/08.webp": 202,
	"./whatsinaname/gallery/innerpage/NewImg/10.webp": 203,
	"./whatsinaname/gallery/innerpage/NewImg/11.webp": 204,
	"./whatsinaname/gallery/innerpage/NewImg/13.webp": 205,
	"./whatsinaname/gallery/innerpage/NewImg/14.webp": 206,
	"./whatsinaname/gallery/innerpage/NewImg/15.webp": 207,
	"./whatsinaname/gallery/innerpage/NewImg/18.webp": 208,
	"./whatsinaname/gallery/innerpage/NewImg/19.webp": 209,
	"./whatsinaname/gallery/innerpage/NewImg/20.webp": 210,
	"./whatsinaname/gallery/innerpage/NewImg/21.webp": 211,
	"./whatsinaname/gallery/innerpage/NewImg/22.webp": 212,
	"./whatsinaname/gallery/innerpage/NewImg/23.webp": 213,
	"./whatsinaname/gallery/innerpage/NewImg/24.webp": 214,
	"./whatsinaname/gallery/innerpage/NewImg/25.webp": 215,
	"./whatsinaname/gallery/innerpage/NewImg/26.webp": 216,
	"./whatsinaname/gallery/innerpage/NewImg/27.webp": 217,
	"./whatsinaname/gallery/innerpage/NewImg/28.webp": 218,
	"./whatsinaname/gallery/innerpage/NewImg/29.webp": 219,
	"./whatsinaname/gallery/innerpage/NewImg/30.webp": 220,
	"./whatsinaname/gallery/innerpage/NewImg/31.webp": 221,
	"./whatsinaname/gallery/innerpage/NewImg/32.webp": 222,
	"./whatsinaname/gallery/innerpage/NewImg/33.webp": 223,
	"./whatsinaname/gallery/innerpage/NewImg/34.webp": 224,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper20.jpg": 225,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper21.jpg": 226,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper22.jpg": 227,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper23.jpg": 228,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper24.jpg": 229,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper25.jpg": 230,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper26.jpg": 231,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper27.jpg": 232,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper28.jpg": 233,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper29.jpg": 234,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper30.jpg": 235,
	"./whatsinaname/gallery/innerpage/NewsPaper/paper31.jpg": 236,
	"./whatsinaname/gallery/old/Image01.png": 360,
	"./whatsinaname/gallery/old/Image02.png": 361,
	"./whatsinaname/gallery/old/Image03.png": 362,
	"./whatsinaname/gallery/old/Image04.png": 363,
	"./whatsinaname/gallery/old/Image05.png": 364,
	"./whatsinaname/innerpagebanners/Aboutbanner.jpg": 365,
	"./whatsinaname/innerpagebanners/about/aboutRight.png": 60,
	"./whatsinaname/innerpagebanners/about/aboutleft.png": 61,
	"./whatsinaname/innerpagebanners/about/abouttop1.png": 62,
	"./whatsinaname/innerpagebanners/about/main.png": 63,
	"./whatsinaname/innerpagebanners/blog/blogmain.png": 237,
	"./whatsinaname/innerpagebanners/breathe/Icon02.png": 64,
	"./whatsinaname/innerpagebanners/breathe/Icon03.png": 65,
	"./whatsinaname/innerpagebanners/breathe/main.png": 66,
	"./whatsinaname/innerpagebanners/contact/404NotFound.jpg": 366,
	"./whatsinaname/innerpagebanners/contact/main.png": 67,
	"./whatsinaname/innerpagebanners/faqs/Image 02.png": 238,
	"./whatsinaname/innerpagebanners/faqs/Image 03.png": 239,
	"./whatsinaname/innerpagebanners/faqs/main.png": 68,
	"./whatsinaname/innerpagebanners/newsevent/main.png": 69,
	"./whatsinaname/innerpagebanners/newsevent/newseventcenter.png": 70,
	"./whatsinaname/innerpagebanners/newsevent/newseventleft.png": 71,
	"./whatsinaname/innerpagebanners/newsevent/newseventright.png": 72,
	"./whatsinaname/innerpagebanners/partnerwithus/Image02.png": 73,
	"./whatsinaname/innerpagebanners/partnerwithus/Image03.png": 74,
	"./whatsinaname/innerpagebanners/partnerwithus/main.png": 75,
	"./whatsinaname/innerpagebanners/service/Image02.png": 76,
	"./whatsinaname/innerpagebanners/service/Image03.png": 77,
	"./whatsinaname/innerpagebanners/service/main.png": 78,
	"./whatsinaname/innerpagebanners/treatment/main.png": 79,
	"./whatsinaname/innerpagebanners/treatment/top.png": 80,
	"./whatsinaname/innerpagebanners/virtualtour/Image01.png": 81,
	"./whatsinaname/innerpagebanners/virtualtour/Image02.png": 82,
	"./whatsinaname/innerpagebanners/virtualtour/Image03.png": 83,
	"./whatsinaname/innerpagebanners/virtualtour/main.png": 84,
	"./whatsinaname/innerpagebanners/virtualtour/main1.jpg": 367,
	"./whatsinaname/ourservice/BloodsInvestigations.png": 51,
	"./whatsinaname/ourservice/DiagnosticServicesInner.png": 52,
	"./whatsinaname/ourservice/HealthHygieneServicesInner.png": 53,
	"./whatsinaname/ourservice/LifestyleMentors.png": 94,
	"./whatsinaname/ourservice/LifestyleMentorsInner.png": 38,
	"./whatsinaname/ourservice/OPDFacility.png": 54,
	"./whatsinaname/ourservice/Pharmacy.png": 55,
	"./whatsinaname/ourservice/SleepConsultation.png": 95,
	"./whatsinaname/ourservice/SleepConsultationInner.png": 39,
	"./whatsinaname/ourservice/SleepDiagnostics.png": 96,
	"./whatsinaname/ourservice/SleepHealthHygiene.png": 97,
	"./whatsinaname/ourservice/SleepTreatment.png": 98,
	"./whatsinaname/ourservice/SpirometryLab.png": 56,
	"./whatsinaname/ourservice/TreatmentServicesInner.png": 40,
	"./whatsinaname/sleepdisorder/AnyAbnormalSleep.png": 101,
	"./whatsinaname/sleepdisorder/Breathlessness.png": 102,
	"./whatsinaname/sleepdisorder/ConsistentNight.png": 103,
	"./whatsinaname/sleepdisorder/DaytimeSleepiness.png": 104,
	"./whatsinaname/sleepdisorder/Fatigue.png": 105,
	"./whatsinaname/sleepdisorder/LackConcentartion.png": 106,
	"./whatsinaname/sleepdisorder/Obesity.png": 107,
	"./whatsinaname/sleepdisorder/PersistentInability.png": 108,
	"./whatsinaname/sleepdisorder/RestlessLeg.png": 109,
	"./whatsinaname/sleepdisorder/SleepinessDuringDriving.png": 110,
	"./whatsinaname/sleepdisorder/Sleeplessness.png": 111,
	"./whatsinaname/sleepdisorder/Snoring.png": 112,
	"./whatsinaname/treamentpackages/GeneralSleepCheckup.png": 240,
	"./whatsinaname/treamentpackages/HealthySleepPack3.png": 241,
	"./whatsinaname/treamentpackages/InsomniaPack1.png": 242,
	"./whatsinaname/treamentpackages/OSAPack2.png": 243,
	"./whatsinaname/treamentpackages/Sleep-Study.jpg": 244,
	"./whatsinaname/treamentpackages/testimonial-1.mp4": 245,
	"./whatsinaname/treamentpackages/testimonial-2.mp4": 246,
	"./woman-brush.png": 368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;